const React = require('react')
const { Container } = require('reactstrap')
require('@styles/components/common/container.style.css')

const CustomContainer = props => {
    const { className } = props

    return (
        <Container fluid className={`${className} custom-container`}>
            {props.children}
        </Container>
    )
}

module.exports = {
    CustomContainer
}
